/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ScorecardTemplateSummary } from './ScorecardTemplateSummary.js';
import {
    ScorecardTemplateSummaryFromJSON,
    ScorecardTemplateSummaryFromJSONTyped,
    ScorecardTemplateSummaryToJSON,
} from './ScorecardTemplateSummary.js';

/**
 * 
 * @export
 * @interface ScorecardTemplateSummaryListResponse
 */
export interface ScorecardTemplateSummaryListResponse {
    /**
     * 
     * @type {Array<ScorecardTemplateSummary>}
     * @memberof ScorecardTemplateSummaryListResponse
     */
    data?: Array<ScorecardTemplateSummary>;
    /**
     * 
     * @type {number}
     * @memberof ScorecardTemplateSummaryListResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardTemplateSummaryListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ScorecardTemplateSummaryListResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof ScorecardTemplateSummaryListResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the ScorecardTemplateSummaryListResponse interface.
 */
export function instanceOfScorecardTemplateSummaryListResponse(value: object): boolean {
    return true;
}

export function ScorecardTemplateSummaryListResponseFromJSON(json: any): ScorecardTemplateSummaryListResponse {
    return ScorecardTemplateSummaryListResponseFromJSONTyped(json, false);
}

export function ScorecardTemplateSummaryListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScorecardTemplateSummaryListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ScorecardTemplateSummaryFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ScorecardTemplateSummaryListResponseToJSON(value?: ScorecardTemplateSummaryListResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ScorecardTemplateSummaryToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

